<script>
  import {onMount} from 'svelte';
  import {fade, scale} from 'svelte/transition';
  import {mobileNonResponsive} from '../../utils/checks';

  export let userType = '';
  export let test = false;

  const documentHeight = Math.max(document.body.offsetHeight, document.body.scrollHeight);
  const useNonResponsiveStyles = mobileNonResponsive();

  let biggerDocument = false;

  onMount(() => {
    biggerDocument = window.innerHeight < documentHeight;
  });
</script>

<div class="scmp_dialog-overlay{test ? ' scmp_novisible' : ''}" style={biggerDocument ? `height:${documentHeight}px` : ''} />
<div class="scmp scmp_Dialog-wrapper{test ? ' scmp_novisible' : ''}" transition:fade={{duration: 400}}>
  <div class="scmp_dialog scmp_user{userType}{useNonResponsiveStyles ? ' scmp_nonresponsive' : ''}" transition:scale={{duration: 400}}>
    <slot />
  </div>
</div>
